// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1CAgZ","row":"Node_row__2RtTb","label":"Node_label__2kMXW","footer":"Node_footer__1V4A0"};